import { API_ORIGIN, authorizedFetch } from '@yeshuman/sdk'
import { useQuery } from '@tanstack/react-query'


export type JobAnalysisCoverageRequirement = {
  label: string
  covered: number
  total: number
}

export type JobAnalysisCoverage = {
  total_candidates: number
  requirements: JobAnalysisCoverageRequirement[]
}

async function fetchJobAnalysisCoverage(opportunityId: string): Promise<JobAnalysisCoverage> {
  const response = await authorizedFetch(
    `${API_ORIGIN}/api/opportunities/managed/${encodeURIComponent(opportunityId)}/analysis-coverage/`,
  )
  if (!response.ok) {
    throw new Error(`Failed to load analysis coverage (${response.status})`)
  }
  return response.json() as Promise<JobAnalysisCoverage>
}

export function jobAnalysisCoverageQueryKey(opportunityId: string) {
  return ['job-analysis-coverage', opportunityId] as const
}

export function useJobAnalysisCoverage(opportunityId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: jobAnalysisCoverageQueryKey(opportunityId ?? ''),
    queryFn: () => fetchJobAnalysisCoverage(opportunityId!),
    enabled: !!opportunityId && enabled,
    staleTime: 5 * 60 * 1000,
  })
}
